module.exports = __webpack_public_path__ + "img/Sosna.7caa3a64.jpg";